<form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="flex justify-between flex-col h-full">
  <div class="text-ladder-black">
    <h1 class="font-bold text-3xl">Login to Account</h1>
    <p class="text-base opacity-80 mt-2">
      Please enter your email and password to continue
    </p>

    <div class="form-group mb-3 mt-4">
      <label for="email">Email Address</label>
      <input
        formControlName="username"
        id="email"
        placeholder="youremail@email.com"
        type="email"
        autocapitalize="off"
      />
      <div *ngIf="loginForm.get('email')?.invalid && loginForm.get('email')?.touched" class="text-red-600 text-sm mt-1">
        <span *ngIf="loginForm.get('email')?.errors?.['required']">Email is required.</span>
        <span *ngIf="loginForm.get('email')?.errors?.['email']">Please enter a valid email address.</span>
      </div>
    </div>

    <div class="form-group">
      <label for="password">Password</label>
      <div class="relative">
        <input
          formControlName="password"
          autocapitalize="off"
          id="password"
          placeholder="&#x2022; &#x2022; &#x2022; &#x2022; &#x2022;"
          [type]="showPassword ? 'text' : 'password'"
        />
        <button
          type="button"
          class="absolute inset-y-0 right-4 flex items-center"
          (click)="showPassword = !showPassword"
        >
          <span
            [class]="showPassword ? 'mdi--eye-off' : 'mdi--eye'"
            class="iconify mdi--eye text-2xl text-[#A6A6A6]"
          ></span>
        </button>
      </div>
      <div *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched" class="text-red-600 text-sm mt-1">
        <span>Password is required.</span>
      </div>
    </div>
    <div class="mt-2">
      <a [routerLink]="'/auth/forgot-password'" class="underline opacity-65 text-base">I’ve forgotten my password.</a>
    </div>

    <p *ngIf="errorMessage" class="text-red-600 mt-4">{{ errorMessage }}</p>
  </div>

  <div class="w-full">
    <app-button type="submit" class="font-bold" [disabled]="loginForm.invalid || loading">
      <span *ngIf="!loading">Sign In</span>
      <span *ngIf="loading">Signing In...</span>
    </app-button>
    <div class="text-center mt-4">
      <span class="opacity-65 font-semibold mr-3">Don’t have an account?</span>
      <a
        [routerLink]="'/auth/register'"
        class="text-ladder-purpleMedium underline font-bold"
        >Create Account</a
      >
    </div>
  </div>
</form>
